var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ImmersivePage",
    {
      attrs: { appBarTitle: _vm.$tr("syncSchedules"), route: _vm.goBackRoute },
    },
    [
      _c(
        "KPageContainer",
        [
          _c(
            "KGrid",
            { attrs: { gutter: "48" } },
            [
              _c("KGridItem", [
                _c("h1", [_vm._v(_vm._s(_vm.$tr("syncSchedules")))]),
              ]),
              _c("KGridItem", [
                _c("p", [_vm._v(_vm._s(_vm.$tr("introduction")))]),
              ]),
              _c(
                "KGridItem",
                {
                  staticClass: "separate",
                  attrs: { layout8: { span: 4 }, layout12: { span: 6 } },
                },
                [
                  _vm.facility
                    ? _c("b", [_vm._v(_vm._s(_vm.facility.name))])
                    : _c("KCircularLoader"),
                ],
                1
              ),
              _c(
                "KGridItem",
                {
                  staticClass: "separate",
                  attrs: {
                    layout: { alignment: "right" },
                    layout8: { span: 4 },
                    layout12: { span: 6 },
                  },
                },
                [
                  _c(
                    "KButton",
                    {
                      on: {
                        click: function ($event) {
                          _vm.deviceModal = true
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$tr("addDevice")) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("CoreTable", {
            scopedSlots: _vm._u([
              {
                key: "tbody",
                fn: function () {
                  return [
                    _vm.scheduledTasks.length > 0
                      ? _c(
                          "tbody",
                          [
                            _c("tr", [
                              _c("th", [
                                _vm._v(
                                  _vm._s(_vm.coreString("deviceNameLabel"))
                                ),
                              ]),
                              _c("th", [_vm._v(_vm._s(_vm.$tr("Schedule")))]),
                              _c("th", [
                                _vm._v(_vm._s(_vm.coreString("statusLabel"))),
                              ]),
                              _c("th"),
                            ]),
                            _vm._l(_vm.scheduledTasks, function (task) {
                              return _c("tr", { key: task.id }, [
                                _c("td", [
                                  _c("span", [
                                    _vm._v(_vm._s(task.deviceName)),
                                    _c("br"),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(task.extra_metadata.baseurl) +
                                        "\n              "
                                    ),
                                  ]),
                                ]),
                                _c("td", [
                                  _c("div", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.scheduleTime(
                                            task.repeat_interval,
                                            task.scheduled_datetime
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]),
                                ]),
                                _c(
                                  "td",
                                  [
                                    task.deviceAvailable
                                      ? _c(
                                          "span",
                                          [
                                            _c("KIcon", {
                                              attrs: { icon: "onDevice" },
                                            }),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.$tr("connected"))
                                              ),
                                            ]),
                                          ],
                                          1
                                        )
                                      : !task.isKDP
                                      ? _c(
                                          "span",
                                          [
                                            _c("KIcon", {
                                              attrs: { icon: "disconnected" },
                                            }),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.$tr("disconnected"))
                                              ),
                                            ]),
                                          ],
                                          1
                                        )
                                      : _c("KEmptyPlaceholder"),
                                  ],
                                  1
                                ),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "KButton",
                                      {
                                        staticClass: "right",
                                        on: {
                                          click: function ($event) {
                                            return _vm.editButton(task)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.coreString("editAction")
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ])
                            }),
                          ],
                          2
                        )
                      : _c("tbody", [
                          _c("tr", [
                            _c("th", [
                              _vm._v(_vm._s(_vm.coreString("deviceNameLabel"))),
                            ]),
                            _c("th", [_vm._v(_vm._s(_vm.$tr("Schedule")))]),
                            _c("th", [
                              _vm._v(_vm._s(_vm.coreString("statusLabel"))),
                            ]),
                            _c("th"),
                          ]),
                          _c("tr", [
                            _c(
                              "td",
                              {
                                staticStyle: { "text-align": "center" },
                                attrs: { colspan: "3" },
                              },
                              [_c("b", [_vm._v(_vm._s(_vm.$tr("NoSync")))])]
                            ),
                          ]),
                        ]),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _vm.deviceModal
            ? _c("SyncFacilityModalGroup", {
                attrs: { facilityForSync: _vm.facility },
                on: {
                  close: _vm.closeModal,
                  syncKDP: _vm.handleKDPSync,
                  syncPeer: _vm.handlePeerSync,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }